import React from 'react';
import pluralize from 'pluralize';
import { showDialog } from '../dialog';
import Tag from '../Tag';
import localization from '../../shared/strings';
import Logger from '../../services/Logger';
import * as utils from '../../shared/utils';

const l18n = localization.TEAMMATES_DIALOG;

/**
 * The same dialog the My team menu shows when the user cannot open team settings.
 */
export default function showNoManageTeamPermissionsDialog({ user, teammates = [], roles = [] }) {
  Logger.log('Ui', 'MyTeamDialogShow');

  const usersWithRoleManageTeam = utils.getTeamManagers(user, teammates, roles);

  showDialog({
    title: l18n.title,
    children: (
      <div className="myTeamDialog">
        {l18n.text(
          usersWithRoleManageTeam.length ? (
            <>
              {pluralize('manager', usersWithRoleManageTeam.length)}{' '}
              {usersWithRoleManageTeam.slice(0, 5).map((teamManager) => (
                <Tag
                  key={teamManager._id}
                  type="user"
                  avatar={teamManager.avatar}
                  text={teamManager.email}
                />
              ))}
            </>
          ) : undefined,
        )}
      </div>
    ),
    textBtnOk: null,
    textBtnCancel: l18n.btnOk,
    onCancel: () => {
      Logger.log('User', 'MyTeamDialogCancel');
    },
  });
}
